import React from 'react';
import styles from './B18.module.scss';
import Text, { TextProps } from '../Text';
import cn from 'classnames';

function B18({ className, children, ...props }: TextProps) {
  return (
    <Text {...props} className={cn(styles.text, className)}>
      {children}
    </Text>
  );
}

export default B18;
